import { FilterGroup } from '../Tools/FilterGroup';
import { KitchenTypeFilter } from '../Filters/KitchenTypeFilter';
import { GenericElement } from '../Elements/GenericElement';
import { FiltersWidget } from '../FiltersWidget';
import { FiltersController } from '../Tools/FiltersController';
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from '../Tools/GlobalMethods';
import { Options } from 'select2';
declare var AssetManagerServices: any;
declare var PlanManager: any;
declare var Savane: any;

export class KitchenFilterWidget extends FilterGroup {
    designerFilterSelectionChanged: any;
    constructor(container: string, kitchenElements: GenericElement[]) {
        super();
        this.id = 'kitchen';
        this.name = 'Cuisine';
        this.icon = 'fas fa-lg fa-utensils';
        this.resource = 'assets';
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new KitchenTypeFilter(kitchenElements, this),
        ];
        this.container = container;
        this.controller = new FiltersController();

        // Listener of the select_webgl_items (sent by cocosplan to inform webgl an item list is selected)
        this.designerFilterSelectionChanged = Savane.eventsManager.instance.addListener(Savane.Events.DESIGNER_FILTER_SELECTION_CHANGED, (event) => {
            var instance = PlanManager.getInstance();
            if (!instance) {
                return false;
            }

            // We will load all door coatings if we don't find anything relevant in the selection
            var selectedEntities = FilterGroup.collectCustomizableEntities(instance.selectedEntities);
            FilterGroup.allIxinaDoorCoatingNewString = null;

            // Only if current selection is 1 item
            if (selectedEntities.length >= 1) {
                // Selected item
                FilterGroup.allIxinaDoorCoatingNewString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(selectedEntities[0]);
                for (var i = 0; i < selectedEntities.length; i++) {
                    let newString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(selectedEntities[i]);
                    if (newString !== FilterGroup.allIxinaDoorCoatingNewString) {
                        FilterGroup.allIxinaDoorCoatingNewString = null;
                        break;
                    }
                }
            } else {
                if (FilterGroup.filters.kitchenElement) {
                    FilterGroup.allIxinaDoorCoatingNewString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(null, FilterGroup.filters.kitchenElement.id);
                }
            }


            if (FilterGroup.allIxinaDoorCoatingNewString) {
                FilterGroup.allIxinaDoorCoatingNewString += FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name';
            }
            // Do we have to reset the door coatings to everything available
            if (FilterGroup.allIxinaDoorCoatingNewString === null) {
                // Set default door coating string
                this.resetDefaultIxinaDoorCoatingString();
            }
            // And finally load all door coatings
            this.loadAllIxinaDoorCoating();
        });
    }

    static getInstance(): KitchenFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'kitchen') as KitchenFilterWidget || null;
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    }

    // Load all coatings for cabinet boxes and doors
    getIxinaCabinetCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allIxinaCabinetCoatings.length !== 0) {
                resolve();
                return;
            }
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_IXINA_COLORIS_CAISSON,COLORIS_GENERIQUES&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaCabinetCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load Ixina Cabinet Coatings !');
                }
            });
        });
        return promise;
    }

    getIxinaSinkCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allIxinaSinkCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for cabinet boxes and doors
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_IXINA_COLORIS_EVIER&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaSinkCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load Ixina Sink Coatings !');
                }
            });
        });
        return promise;
    }

    getIxinaMixerCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allIxinaMixerCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for cabinet boxes and doors
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_IXINA_COLORIS_MITIGEUR&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaMixerCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load Ixina Mixer Coatings !');
                }
            });
        });
        return promise;
    }

    getIxinaGuttersCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allIxinaGutterCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for gutters
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_IXINA_COLORIS_POIGNEE_LINE-N&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaGutterCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load Ixina Gutter Coatings !');
                }
            });
        });
        return promise;
    }

    getIxinaBaseBoardCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allIxinaPlinthCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for cabinet boxes and doors
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_IXINA_COLORIS_PLINTH,COLORIS_GENERIQUES&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaPlinthCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load Ixina Base_Board Coatings !');
                }
            });
        });
        return promise;
    }

    getIxinaHandles(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allKitchenHandleModels.length !== 0) {
                resolve();
                return;
            }
            // Load all Ixina handles
            AssetManagerServices.getHandles(AssetManagerServices.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.eq=662bb10916eb511a1c89d3ff', '5d00daa0b846d52308a350e4', function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allKitchenHandleModels = resources;
                    resolve();
                }
                else {
                    reject('Failed to load Ixina Handles !');
                }
            });
        });
        return promise;
    }

    initialiseDoorCoatings(): Promise<void> {
        // We will load all door coatings if we don't find anything relevant in the selection
        var selectedEntities = FilterGroup.collectCustomizableEntities(PlanManager.getInstance().selectedEntities);
        FilterGroup.allIxinaDoorCoatingNewString = null;

        // Only if current selection is 1 item
        if (selectedEntities.length >= 1) {
            // Selected item
            FilterGroup.allIxinaDoorCoatingNewString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(selectedEntities[0]);
            for (var i = 1; i < selectedEntities.length; i++) {
                let newString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(selectedEntities[i]);
                if (newString !== FilterGroup.allIxinaDoorCoatingNewString) {
                    FilterGroup.allIxinaDoorCoatingNewString = null;
                    break;
                }
            }
        } else {
            if (FilterGroup.filters.kitchenElement) {
                FilterGroup.allIxinaDoorCoatingNewString = Savane.Commands.ChangeKitchenCoatingCommand.getDoorCoatingStringFilter(null, FilterGroup.filters.kitchenElement.id);
            }
        }

        if (FilterGroup.allIxinaDoorCoatingNewString) {
            FilterGroup.allIxinaDoorCoatingNewString += FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name';
        }
        // Do we have to reset the door coatings to everything available
        if (FilterGroup.allIxinaDoorCoatingNewString === null) {
            // Set default door coating string
            this.resetDefaultIxinaDoorCoatingString();
            // FilterGroup.allIxinaDoorCoatingCurrentString = '';
        }
        // And finally load all door coatings
        return this.loadAllIxinaDoorCoating();
    };

    // Load all door coatings
    loadAllIxinaDoorCoating(): Promise<void> {
        let fetchPromise = new Promise<boolean>((resolve, reject) => {
            // Only if we are in the kitchen tab of the designer filter tool
            if (!FiltersWidget.currentFiltersGroup || FiltersWidget.currentFiltersGroup.id !== 'kitchen') {
                resolve(false);
                return;
            }

            // Load ressources from AM ONLY if different than previous call
            if (FilterGroup.allIxinaDoorCoatingCurrentString === FilterGroup.allIxinaDoorCoatingNewString) {
                resolve(false);
                return;
            }

            // Transfer new string into current
            FilterGroup.allIxinaDoorCoatingCurrentString = FilterGroup.allIxinaDoorCoatingNewString;
            // Then load all coatings for Ixina doors
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FilterGroup.allIxinaDoorCoatingCurrentString, function (res) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allIxinaDoorCoatings = resources;
                    resolve(true);
                } else {
                    reject('Failed to load Ixina Door Coatings !');
                }
            });
        });
        let promise = new Promise<void>((resolve) => {
            fetchPromise.then((changed) => {
                const widget = KitchenFilterWidget.getInstance();
                if (changed) {
                    $("#Porte-parent").html(widget.getIxinaDoorsHtml());
                } else widget.updateActive(FilterGroup.allIxinaDoorCoatings, 'Porte');
                resolve();
            });
        });
        return promise;
    };

    // Resets the new coating string to the default (we will call it in case of multiple selection)
    resetDefaultIxinaDoorCoatingString() {
        // Get all customizable entities
        var entities = FilterGroup.collectCustomizableEntities(PlanManager.getInstance().world.currentScene.currentFloor.iArrangements);
        // String array to store all kitchen customization
        var stringList = [];
        // Loop variable
        var i;

        // Parse all collected arrangement objets
        for (i = 0; i < entities.length; ++i) {
            var item = entities[i];

            if (FiltersWidget.ArrangementType.kitchenCustomizableArrangements.indexOf(item.objectType) === -1) {
                continue;
            }

            if (item.customization.expectedParts) {
                // Loop variable
                var j;

                // Parse expected parts to find door expected part
                for (j = 0; j < item.customization.expectedParts.length; j++) {
                    if (item.customization.expectedParts[j].name.includes('Porte')) {
                        break;
                    }
                }

                // Found ?
                if (j < item.customization.expectedParts.length) {
                    // Get all groups and create string for filter door coatings
                    for (var k = 0; k < item.customization.expectedParts[j].groups.length; k++) {
                        if (stringList.indexOf(item.customization.expectedParts[j].groups[k].name) === -1) {
                            stringList.push(item.customization.expectedParts[j].groups[k].name);
                        }
                    }
                }
            }
        }

        FilterGroup.allIxinaDoorCoatingNewString = '&q.customizationGroups.name.in=';

        // At least one door customizable object collected
        if (stringList.length > 0) {
            for (i = 0; i < stringList.length; ++i) {
                if (i > 0) {
                    FilterGroup.allIxinaDoorCoatingNewString += ',';
                }
                FilterGroup.allIxinaDoorCoatingNewString += encodeURIComponent(stringList[i]);
            }
        }
        else {
            // TODO verify CG_ names here
            FilterGroup.allIxinaDoorCoatingNewString += 'CG_IXINA_COLORIS_LISSE,CG_IXINA_COLORIS_CADRE_DELIA,CG_IXINA_COLORIS_CADRE_SUEDE,CG_IXINA_COLORIS_LINE-N,COLORIS_GENERIQUES';
        }

        FilterGroup.allIxinaDoorCoatingNewString += FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name';
    };

    loadAllAssets(): Promise<void[]> {
        const cabinetPromise = this.getIxinaCabinetCoatings();
        const doorPromise = this.initialiseDoorCoatings();
        const sinkPromise = this.getIxinaSinkCoatings();
        const mixerPromise = this.getIxinaMixerCoatings();
        const gutterPromise = this.getIxinaGuttersCoatings();
        const baseBoardPromise = this.getIxinaBaseBoardCoatings();
        const handlePromise = this.getIxinaHandles();

        return Promise.all([
            cabinetPromise, doorPromise,
            sinkPromise, mixerPromise,
            gutterPromise, baseBoardPromise,
            handlePromise
        ]);
    }

    updateAllActiveLists() {
        this.initialiseDoorCoatings().then(() => {
            this.updateActive(FilterGroup.allIxinaCabinetCoatings, 'Caisson');
            const hasSink = FilterGroup.selectedArrangementsHas('Evier');
            $('#hasFeatureEvier').css('display', hasSink ? '' : 'none');
            if (hasSink) {
                this.updateActive(FilterGroup.allIxinaSinkCoatings, 'Evier');
                this.updateActive(FilterGroup.allIxinaMixerCoatings, 'Mitigeur');
            }

            const hasGutter = FilterGroup.selectedArrangementsHas('Gouttiere');
            $('#hasFeatureGouttiere').css('display', hasGutter ? '' : 'none');
            if (hasGutter) {
                this.updateActive(FilterGroup.allIxinaGutterCoatings, 'Gouttiere');
            }

            this.updateActive(FilterGroup.allIxinaPlinthCoatings, "BaseBoard", "baseboard");
            this.updateActive(FilterGroup.allKitchenHandleModels, "Handle", "handle");
        });
    }

    selectionListener: () => void;
    html(): void {
        this.isDestroyed = false;
        this.loadAllAssets().then(() => {
            this.selectionListener = () => { this.updateAllActiveLists(); };
            FilterGroup.addEntitySelectionListener(this.selectionListener);
            let html = this.filters[0].html() + `
            <div>
                <h style="font-weight:600;">Personnalisation</h>
                <div class="padding">
                    <div style="display:contents" id="Caisson-parent">
                        ${this.getIxinaBoxShelvesHtml()}
                    </div>
                    <div style="display:contents" id="Porte-parent">
                        ${this.getIxinaDoorsHtml()}
                    </div>
                    <div id="hasFeatureEvier" ${FilterGroup.selectedArrangementsHas('Evier') ? '' : 'style="display:none"'}>
                        <div style="display:contents" id="Evier-parent">
                            ${this.getIxinaSinkHtml()}
                        </div>
                        <div style="display:contents" id="Mitigeur-parent">
                            ${this.getIxinaMixerHtml()}
                        </div>
                    </div>
                    <div style="display:contents" id="BaseBoard-parent">
                        ${this.getIxinaBaseBoardsHtml()}
                    </div>
                    <div id="hasFeatureGouttiere" ${FilterGroup.selectedArrangementsHas('Gouttiere') ? '' : 'style="display:none"'}>
                        <div style="display:contents" id="Gouttiere-parent">
                            ${this.getIxinaGuttersHtml()}
                        </div>
                    </div>
                    <div style="display:contents" id="Handle-parent">
                        ${this.getIxinaHandlesHtml()}
                    </div>
                </div>
                <div style="margin-top: 10px;">
                    ${this.getIxinaChangeSelectorHtml()}
                </div>
                <div style="margin-top: 20px;">
                    ${this.getKitchenToolsHtml()}
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
        });
    }

    updateActive(objects: any[], customName: string, type?: string) {
        objects.forEach((object) => {
            FilterGroup.cache.name = "";
            let isActive: boolean;
            switch (type) {
                case "handle":
                    isActive = FilterGroup.isHandleUsed(object, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
                    break;
                case "baseboard":
                    isActive = FilterGroup.isPlinthCoatingUsed(object, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
                    break;
                default:
                    isActive = FilterGroup.isCoatingUsed(object, customName, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
            }
            let display = isActive ? "" : "none";
            $(`#active-${object.name}-${customName}`).css('display', display);
        })
    }

    getCoatingsHtml(title: string, coatings: any[], customName: string, getPreviewUrl: (coating: any) => string): string {
        FilterGroup.cache.name = "";
        let coatingsHtml = coatings.map((coating) => {
            const updateFunc = () => {
                FilterGroup.updateArrangementCoating(coating, customName, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
                this.updateActive(coatings, customName);
            }
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    updateFunc();
                }, `${customName}-${coating.name}-title`);

                this.controller.addEventListener('click', () => {
                    updateFunc();
                }, `${customName}-${coating.name}-img`);
            }, 50);

            let isUsed = FilterGroup.isCoatingUsed(coating, customName, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);

            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${coating.name}" id="${customName}-${coating.name}-title">
                    </div>
                    <img style="width:50px;height:50px;" id="${customName}-${coating.name}-img" src="${getPreviewUrl(coating)}">
                    <div id="active-${coating.name}-${customName}" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                        <i class="glyphicon glyphicon-ok"></i>
                    </div>
                </div>
            `;
        }).join('');
        return `
        <div>
            <div style="text-align: left; margin-left: 10px;">${title}</div>
            <div style="margin-bottom:10px;padding:0;width: 100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
                ${coatingsHtml}
            </div>
        </div>
        `;
    }

    getIxinaBoxShelvesHtml(): string {
        return this.getCoatingsHtml(
            "Ixina Caissons/Etagères",
            FilterGroup.allIxinaCabinetCoatings,
            'Caisson',
            FilterGroup.getCabinetCoatingPreviewUrl
        );
    }

    getIxinaDoorsHtml(): string {
        return this.getCoatingsHtml(
            "Ixina Portes",
            FilterGroup.allIxinaDoorCoatings,
            'Porte',
            FilterGroup.getCabinetCoatingPreviewUrl
        );
    }

    getIxinaSinkHtml(): string {
        return this.getCoatingsHtml(
            "Ixina Evier",
            FilterGroup.allIxinaSinkCoatings,
            'Evier',
            FilterGroup.getCabinetCoatingPreviewUrl
        );
    }

    getIxinaMixerHtml(): string {
        return this.getCoatingsHtml(
            "Ixina Mitigeur",
            FilterGroup.allIxinaMixerCoatings,
            'Mitigeur',
            FilterGroup.getCabinetCoatingPreviewUrl
        );
    }

    getIxinaBaseBoardsHtml(): string {
        let coatingsHtml = FilterGroup.allIxinaPlinthCoatings.map((coating) => {
            let updateFunc = () => {
                FilterGroup.updateArrangementPlinthCoating(coating, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
                this.updateActive(FilterGroup.allIxinaPlinthCoatings, "BaseBoard", "baseboard");
            }
            setTimeout(() => {
                this.controller.addEventListener("click", updateFunc, `BaseBoard-${coating.name}-title`);
                this.controller.addEventListener("click", updateFunc, `BaseBoard-${coating.name}-img`);
            }, 50);
            let selected = FilterGroup.isPlinthCoatingUsed(coating, FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${coating.name}" id="BaseBoard-${coating.name}-title">
                    </div>
                    <img style="width:50px;height:50px;" src="${FilterGroup.getCabinetCoatingPreviewUrl(coating)}"
                        id="BaseBoard-${coating.name}-img">
                    <div id="active-${coating.name}-BaseBoard" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${selected ? '' : 'display:none'}">
                        <i class="glyphicon glyphicon-ok"></i>
                    </div>
                </div>
            `;
        }).join('');
        return `
        <div>
            <div style="text-align: left; margin-left: 10px;">Ixina Plinthes</div>
            <div style="margin-bottom:10px;padding:0;width:100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
                ${coatingsHtml}
            </div>
        </div>
        `;
    }

    getIxinaGuttersHtml(): string {
        return this.getCoatingsHtml(
            "Ixina Gouttières LineN",
            FilterGroup.allIxinaGutterCoatings,
            'Gouttiere',
            FilterGroup.getCabinetCoatingPreviewUrl
        );
    }

    getIxinaHandlesHtml(): string {
        FilterGroup.cache.name = "";
        let handlesHtml = FilterGroup.allKitchenHandleModels.map((modele) => {
            let updateFunc = () => {
                FilterGroup.updateArrangementHandleModeleType(modele, FiltersWidget.ArrangementType.kitchenCustomizableArrangements).then(() => {
                    this.updateActive(FilterGroup.allKitchenHandleModels, "Handle", "handle");
                });
            }
            setTimeout(() => {
                this.controller.addEventListener("click", updateFunc, `Handle-${modele.name}-title`);
                this.controller.addEventListener("click", updateFunc, `Handle-${modele.name}-img`);
            }, 50);
            let selected = FilterGroup.isHandleUsed(modele, FiltersWidget.ArrangementType.kitchenCustomizableArrangements)
            return `
                <div style="cursor: pointer;display:inline-block;width:70px;height:70px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:70px;height:70px;background-color:#f5d23100;"
                        title="${modele.name}" id="Handle-${modele.name}-title">
                    </div>
                    <img style="width:70px;height:70px;" src="${FilterGroup.getHandlePreviewUrl(modele)}"
                        id="Handle-${modele.name}-img">
                    <div id="active-${modele.name}-Handle" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${selected ? '' : 'display:none'}">
                        <i class="glyphicon glyphicon-ok"></i>
                    </div>
                </div>
            `;
        }).join('');

        setTimeout(() => {
            this.controller.addEventListener("click", () => {
                FilterGroup.removeArrangementHandleModel(FiltersWidget.ArrangementType.kitchenCustomizableArrangements);
                this.updateActive(FilterGroup.allKitchenHandleModels, "Handle", "handle");
            }, `NoHandle`);
        }, 50);

        return `
        <div>
            <div style="text-align: left; margin-left: 10px;">Poignées</div>
            <div
                style="padding:0;width:100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
                ${handlesHtml}
                <div title="Pas de poignée" id="NoHandle"
                    style="cursor: pointer;display:inline-block;width:70px;height:30px;position:relative">
                    <i class="far fa-2x fa-trash-alt" style="vertical-align: middle;"></i>
                </div>
            </div>
        </div>
        `;
    }

    getIxinaChangeSelectorHtml(): string {
        setTimeout(() => {
            checkAndDestroySelect2('kitchenStyleInput');
            const data = FiltersWidget.kitchenStyles.map((element) => {
                return {
                    id: element.id || '-1',
                    text: element.name,
                    title: this.name,
                    selected: element.name === FiltersWidget.newKitchenStyle.name,
                };
            });

            $('#kitchenStyleInput').select2({
                placeholder: {
                    id: '-2',
                    text: 'Choisissez un nouveau type de cuisine'
                },
                data: [
                    {
                        id: '-2',
                        text: 'Choisissez un nouveau type de cuisine'
                    },
                    ...data
                ],
                width: 'element',
                selectionCssClass: 'select-control',
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
            } as Options);

            $('#kitchenStyleInput').on('change.select2', () => {
                let selectedValue = $('#kitchenStyleInput').val() as string;
                if (selectedValue === '-1') {
                    FiltersWidget.newKitchenStyle = null;
                }
                else {
                    FiltersWidget.newKitchenStyle = FiltersWidget.kitchenStyles.find((element) => selectedValue === element.id) || null;
                }

                FiltersWidget.triggerDesignerFilterSelectionChanged();
                // FilterGroup.getUpdateFunctions(this.filtersFunction)(FilterGroup.filters);
            });

            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.changeStyleAllKitchen();
            }, "changeStyleAllKitchen");

            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.changeStyleTopKitchen();
            }, "changeStyleTopKitchen");

            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.changeStyleBottomKitchen();
            }, "changeStyleBottomKitchen");

        }, 50);
        return `
        <div style="text-align: left; margin-left: 10px;">Changer de style de cuisine</div>
        <select id="kitchenStyleInput" style="max-width: 380px;width: 100%;margin:0 auto;" 
            title="${this.name}"></select>
        <button class="btn-default" id="changeStyleAllKitchen" title="Changer tout">
            <i class="fas fa-lg fa-rotate"></i>
            <span style="margin-left: 10px;">Changer tout</span>
        </button>
        <i class="fa-sharp fa-regular fa-arrow-down-to-line"></i>
        <button class="btn-default" id="changeStyleTopKitchen" title="Changer meuble hauts">
            <i class="fas fa-lg fa-arrow-up"></i>
            <span style="margin-left: 10px;">Changer meubles hauts</span>
        </button>
        <button class="btn-default" id="changeStyleBottomKitchen" title="Changer meuble bas">
            <i class="fas fa-lg fa-arrow-down"></i>
            <span style="margin-left: 10px;">Changer meubles bas + colonnes</span>
        </button>
        `;
    }

    getKitchenToolsHtml(): string {
        setTimeout(() => {
            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.setWorktopMode();
            }, "worktopModeBtn");

            this.controller.addEventListener('mousedown', () => {
                FiltersWidget.sendEvent('toggle_sketch_mode_event');
            }, "sketchModeToggle");
        }, 50);
        return `
        <button class="btn-default" id="worktopModeBtn" title="Designer de plans de travail">
            <i class="fas fa-lg fa-ruler-combined"></i>
            <span style="margin-left: 10px;">Plans de travail</span>
        </button>
        <button class="btn-default" id="sketchModeToggle" title="Mode d'affichage">
            <i class="fas fa-lg fa-tv"></i>
            <span style="margin-left: 10px;">Mode d'affichage</span>
        </button>
        `;
    }

    destroy(): void {
        super.destroy();
        checkAndDestroySelect2('kitchenStyleInput');
        Savane.eventsManager.instance.removeListener(this.designerFilterSelectionChanged);
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
            this.selectionListener = undefined;
        }
    }
}